<script>
    import {userStore} from '@js/stores/userStore';
    import {mapStore} from '@js/stores/mapStore';

    import AnalyticsService from '@js/modules/analyticsService';
    import {MAP_MODULES} from '@js/modules/maps/mapConstants';

    import BuildMap from '@js/components/maps/BuildMap.svelte';
    import PlannerMapExtras from '@js/components/maps/PlannerMapExtras.svelte';
    import MapPlanningTools from '@js/components/maps/MapPlanningTools.svelte';

    // Save-nudge only targets unconnected visitors — code-split and never loaded for connected users.
    const MapSaveNudge = () => import('@js/components/maps/MapSaveNudge.svelte');
    const MapStageSummary = () => import('@js/components/maps/MapStageSummary.svelte');

    const {mapId} = $props();

    // Daily stages of a multi-day route, under the map, next to what they show. Re-read as the route or
    // its stops change.
    const stageSummary = $derived.by(() => {
        void $mapStore.currentDistance;
        void $mapStore.currentBreakTime;

        return mapStore.map?.getStageSummary ? mapStore.map.getStageSummary() : [];
    });

    // A day shows where it ends: the map comes into view, centered there.
    const _showStage = (stage) => {
        document.getElementById(mapId)?.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        mapStore.map?.flyTo(stage.end, 15);
    };
</script>

<!-- The planner reuses the shared BuildMap (same tools as the home map): route type comes from the
     planner search bar so the toolbar's own selector is off, and the planner-only panels (reachable zone,
     loop) are layered on the map via the mapExtras snippet. POI editing + save come from RideCreation,
     mounted alongside by plannerManager. -->
<!-- Multi-day stage splitting + auto POI suggestions: a planning-only feature shown ABOVE the map, in the
     card of the route options, so the possibilities are visible before drawing (disabled until a route
     exists). It stays open once opened; its daily stages are listed under the map. -->
<MapPlanningTools boxed={true} showStages={false}/>

<BuildMap mapId={mapId}
          reusePreviousTracks={false}
          useRouteType={false}
          onPathStarted={() => AnalyticsService.trackPlannerPathStarted()}
          extraModules={[MAP_MODULES.ISOCHRONE]}
          deferredExtraModules={[MAP_MODULES.ISOCHRONE]}>
    {#snippet mapExtras()}
        <PlannerMapExtras/>
    {/snippet}
</BuildMap>

{#if stageSummary.length > 1}
    <div class="planner-stage-summary mx-auto mb-6 w-[94%] max-w-4xl">
        {#await MapStageSummary() then StageSummary}
            <StageSummary.default stages={stageSummary} onSelect={_showStage}/>
        {/await}
    </div>
{/if}

{#if !$userStore.isConnected && $mapStore.currentDistance}
    {#await MapSaveNudge() then Nudge}
        <Nudge.default/>
    {/await}
{/if}
